import styles from "./empty.block.module.css";

export default function EmptyBlock({ title }) {
    return (
      <div className={styles.container}>
        <span className={styles.title}>{title}</span>
      </div>
    )
}